import _ from 'underscore';
import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useConstructor } from '@bingads-webui-campaign/hooks';
import { perfMarkerPropTypes } from '@bingads-webui/performance-marker';
import { useReportsHistory } from '@bingads-webui-campaign/reports-v4-history';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { Pivot, PivotItem } from '@fluentui/react';
import { useReportDataSource } from '@bingads-webui-campaign/reports-v4-data-source';
import { SummaryBar, Divider } from '@bingads-webui-campaign/reports-v4-summary-bar';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { MyReportsGrid } from './grid';
import getStyles from './style/index';

const pivotStyle = {
  root: {
    paddingLeft: 32,
    background: '#fff',
    width: '100%',
  },
  // Fix bug 4007317: When page size is 200, grid has white space issue - some grid rows not rendered
  // Use inline style instead of JSS to ensure style is present in componentDidMount
  itemContainer: {
    flex: 1,
    overflow: 'auto',
    '& .tab-content': {
      height: '100%',
    },
  },
};
function MyReportsPage(props) {
  const { classes, type, perfMarker } = props;
  const history = useReportsHistory();
  function changeRoute(item) {
    history.push(`/campaign/vnext/reports-v4/my-reports/${item.props.itemKey}`);
  }

  const [counts, setCounts] = useState([0, 0]);
  const i18n = useContext(I18nContext);
  const reportsApiProps = useReportDataSource();
  const serverContext = useContext(ServerContext);
  const [myReportsPerfMarker] = useConstructor(() => {
    const marker = perfMarker.createChild('My_Reports');
    marker.willInit();
    return marker;
  });
  useEffect(() => {
    reportsApiProps.getMyReportsCounts().then((res) => {
      setCounts(res);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      <SummaryBar>
        <Divider />
        <span style={{ marginLeft: 8 }}>{i18n.getString(_TL_('My reports'))}</span>
      </SummaryBar>
      <section className={`my-reports-container ${classes.myReportsContainer}`}>
        <Pivot selectedKey={type} onLinkClick={changeRoute} styles={pivotStyle} className="tab-header">
          <PivotItem headerText={`${i18n.getString(_TL_('Saved customized reports'))} (${counts[0]})`} itemKey="customized" className="tab-content">
            <MyReportsGrid type="Saved" classes={classes} updateCount={count => setCounts([count, counts[1]])} perfMarker={myReportsPerfMarker} />
          </PivotItem>
          {!serverContext.Permissions.IsInternalUser &&
          <PivotItem headerText={`${i18n.getString(_TL_('Reports shared with me'))} (${counts[1]})`} itemKey="shared" className="tab-content">
            <MyReportsGrid type="Shared" classes={classes} updateCount={count => setCounts([counts[0], count])} perfMarker={myReportsPerfMarker} />
          </PivotItem>
          }
        </Pivot>
      </section>
    </React.Fragment>
  );
}

MyReportsPage.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  type: PropTypes.string.isRequired,
  history: PropTypes.shape({}).isRequired,
  i18n: PropTypes.shape({}).isRequired,
  perfMarker: perfMarkerPropTypes.isRequired,
};

MyReportsPage.defaultProps = {
};

const wrappers = [
  _.partial(withDefaultStyles, _, getStyles),
];

const Wrapped = _.compose(...wrappers)(MyReportsPage);

export { Wrapped as MyReports };

